import React, { useState, useEffect, useCallback, useMemo, useContext } from "react";
import toast from "react-hot-toast";
import { FaEdit } from "react-icons/fa";
import { RiDeleteBin6Fill } from "react-icons/ri";
import CreateLedger from "../../TypesAndGroups/Ladgers/CreateLadger";
import Pagination, { usePagination } from "../../../Components/CommonComponent/Pgination/pagination";
import AddButton from "../../../Components/CommonComponent/Button/AddButton";
import DeleteDataModal from "../../../Components/CommonComponent/Modals/DeleteDataModal";
import { CommonContext } from "../../../App";
import { useTranslation } from "react-i18next";
import api from "../../../services/api";
import RecoverDeleteDataModal from "../../../Components/CommonComponent/Modals/RecoverDeleteDataModal";
import { SlReload } from "react-icons/sl";
export default function DeletedLedgersData() {
  const { t } = useTranslation();
  // State management
  const [ledgers, setLedgers] = useState({ allData: [], pagination: { totalRecords: 0 } });
  const [loading, setLoading] = useState(false);
  const { branchId } = useContext(CommonContext)
  const [modalVisible, setModalVisible] = useState(false);
  const [modalDelete, setModalDelete] = useState(false);
  const [selectedLedger, setSelectedLedger] = useState(null);
  const storedLang = JSON.parse(localStorage.getItem("second_language"));
   const language = storedLang?.language || "en";
  // Constants



  // Pagination hook
  const {
    currentPage,
    itemsPerPage,
    handlePageChange,
    handleItemsPerPageChange,
    resetPagination,
    getPaginatedData
  } = usePagination(10);

  // Memoized pagination data
  const paginationData = useMemo(() => {
    return getPaginatedData(ledgers);
  }, [ledgers, getPaginatedData]);

  // Memoized serial number calculation
  const getSerialNumber = useCallback((index) => {
    return (currentPage - 1) * itemsPerPage + index + 1;
  }, [currentPage, itemsPerPage]);

  // Fetch ledger data - memoized to prevent unnecessary re-renders
  const fetchLedgerData = useCallback(async () => {
    try {
      setLoading(true);
      const response = await api.get(`ledgers/get-all-delete-ledger?page=${currentPage}&limit=${itemsPerPage}&branchId=${branchId}&type=Assets,Income,Expense,Liability`);

      // Expecting API to return either { success, data: [], totalRecords } or { success, allData: [], pagination: { totalRecords } }
      if (response.data?.success) {
        const payload = response.data;
        const allData = Array.isArray(payload?.data)
          ? payload.data
          : (Array.isArray(payload?.allData) ? payload.allData : []);
        const totalRecords = payload?.totalRecords ?? payload?.pagination?.totalRecords ?? allData.length;
        setLedgers({ allData, pagination: { totalRecords } });
      } else {
        toast.error(response.data?.message || "Failed to fetch ledgers");
        setLedgers({ allData: [], pagination: { totalRecords: 0 } });
      }
    } catch (error) {
      console.error("Error fetching ledgers:", error);
      toast.error(error.response?.data?.message || "Error fetching ledgers");
      setLedgers({ allData: [], pagination: { totalRecords: 0 } });
    } finally {
      setLoading(false);
    }
  }, [ currentPage, itemsPerPage, branchId]);

  // Effect to fetch data on component mount
  useEffect(() => {
   if(branchId) fetchLedgerData();
  }, [fetchLedgerData]);

  // Memoized handlers to prevent unnecessary re-renders



  // const handleAddGroup = useCallback(() => {
  //   setSelectedLedger(null);
  //   setModalVisible(true);
  // }, []);

  const handleEditLedger = useCallback((ledger) => {
    setSelectedLedger(ledger);
    setModalVisible(true);
  }, []);

  const handleDeleteLedger = useCallback((ledger) => {
    setSelectedLedger(ledger);
    setModalDelete(true);
  }, []);

  const handleModalClose = useCallback(() => {
    setModalVisible(false);
    setSelectedLedger(null);
  }, []);

  const handleDeleteModalClose = useCallback(() => {
    setModalDelete(false);
    setSelectedLedger(null);
  }, []);

  const handleLedgerUpdate = useCallback(() => {
    fetchLedgerData();
    setSelectedLedger(null);
    handleModalClose();
  }, [fetchLedgerData]);



  // Memoized table rows to prevent unnecessary re-renders
  const tableRows = useMemo(() => {
    return paginationData.currentItems?.map((ledger, index) => (
      <tr key={ledger.id || ledger.groupId || index} className="bg-theme-tableBg hover:bg-theme-tableHoverColor ">
        <td className="border-b px-1 text-center">
          {getSerialNumber(index)}
        </td>
        <td className="border-b py-[2px] px-1">
          {ledger.name || "-"} {language!=="en" && (ledger.cousinName && ` (${ledger.cousinName})`)}
        </td>
        <td className={`border-b px-1 ${ledger.address === "unknown" ? "text-center" : ""
          }`}>
          {ledger.address === "unknown" ? "-" : ledger.address || ""}
        </td>
        <td className={`border-b px-1 ${ledger.phone === "unknown" ? "text-center" : ""
          }`}>
          {ledger.phone === "unknown" ? "-" : ledger.phone || ""}
        </td>
        <td className="border-b px-1">
          {ledger.groupType}/{ledger.groupName}
          {ledger.subGroupName && `/${ledger.subGroupName}`}
        </td>
        <td className="border-b px-1">
          <div className="flex justify-center gap-2">
            {/* <FaEdit
              title="Edit ledger"
              onClick={ledger.branchId !== 0 ? () => handleEditLedger(ledger) : undefined}
              className={
                ledger.branchId !== 0
                  ? "text-gray-700 mt-1 cursor-pointer hover:text-theme-btnBg transition-colors"
                  : "text-gray-400 mt-1 opacity-50 pointer-events-none"
              }
            />
            <RiDeleteBin6Fill
              title="Delete ledger"
              onClick={ledger.branchId !== 0 ? () => handleDeleteLedger(ledger) : undefined}
              className={
                ledger.branchId !== 0
                  ? "text-red-700 mt-1 cursor-pointer hover:text-red-800 transition-colors"
                  : "text-red-400 mt-1 opacity-50 pointer-events-none"
              }
            /> */}
               <SlReload 
              className="text-gray-700 mt-1 cursor-pointer hover:text-theme-btnBg transition-colors"
                   onClick={() => {
                    handleDeleteLedger(ledger)
                }}
                 title="recycle ledger"
                />
          </div>
        </td>
      </tr>
    ));
  }, [paginationData.currentItems, getSerialNumber, handleEditLedger, handleDeleteLedger]);

  return (
    <div className="py-2 flex justify-center">
      <div className="flex flex-col justify-center  w-full">
        {/* Header */}
        <div className="flex justify-between py-[2px] items-center  bg-theme-headerBg px-2 text-theme-color">
          <div className="   font-medium">{t('ledgers')} </div>
          {/* <div className="">
            <AddButton onClick={handleAddGroup} text={t("add")} />
          </div> */}
        </div>

        {/* Loading State */}
        {loading && (
          <div className="flex justify-center items-center py-8">
            <div className="text-gray-500">Loading ledgers...</div>
          </div>
        )}

        {/* Ledger List */}
        {!loading && (ledgers?.pagination?.totalRecords ?? 0) === 0 ? (
          <p className="text-gray-500 italic text-center py-8">
            {t('noDataAvailable')}
          </p>
        ) : !loading && (
          <div className="overflow-x-auto">
            <table className="w-full rounded-lg border border-separate border-spacing-0 text-sm">
              <thead>
                <tr className="bg-theme-tableBg text-theme-headerBg border-theme-headerBg">
                  <th className="border-b px-1 font-medium text-center">{t("srNumber")}</th>
                  <th className="border-b py-[2px] px-1 font-medium text-left">{t('name')} </th>
                  <th className="border-b px-1 font-medium text-left">{t('address')} </th>
                  <th className="border-b px-1 font-medium text-left">{t('phone')} </th>
                  <th className="border-b px-1 font-medium text-left">{t('type&Group')} </th>
                  <th className="border-b px-1 font-medium text-center">{t('action')} </th>
                </tr>
              </thead>
              <tbody>
                {tableRows}
              </tbody>
            </table>

            {/* Pagination Component */}
            <Pagination
              data={ledgers}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              onPageChange={handlePageChange}
              onItemsPerPageChange={handleItemsPerPageChange}
              itemsPerPageOptions={[10, 20, 50, 100]}
              showItemsPerPageSelector={true}
              showPageInfo={true}
              position="bottom-center"
            />
          </div>
        )}
      </div>

      {/* Edit Ledger Modal */}
      {/* {modalVisible && (
        <div
          className="fixed inset-0 bg-black/20 bg-opacity-40 flex justify-center items-center z-[1000]"
          onClick={handleModalClose}
        >
          <div
            className="rounded max-w-5xl text-start max-h-[70vh] w-full shadow-lg overflow-y-auto "
            onClick={(e) => e.stopPropagation()}
          >
            <CreateLedger
              setModalVisible={setModalVisible}
              onUpdateLedger={handleLedgerUpdate}
              ledgerData={selectedLedger}
              updateLedger={fetchLedgerData}
            />
          </div>
        </div>
      )} */}
      {modalDelete && (
        <RecoverDeleteDataModal
          selectedLedger={selectedLedger}
          handleModalClose={handleDeleteModalClose}
          handleRecoverApi={async (ledger) => {
            try {
              const res = await api.post(`ledgers/recycle-ledger?id=${ledger.id}`, {
                isDelete: 0, branchId // soft delete
              });

              if (res.data.success) {
                toast.success(res.data.message || "Ledger recovered successfully");

                // ✅ Re-fetch ledgers to update table
                fetchLedgerData();

                // Optional: Adjust current page if last item on page was deleted
                const totalRecordsAfterDelete = (ledgers?.pagination?.totalRecords ?? 1) - 1;
                const totalPagesAfterDelete = Math.ceil(totalRecordsAfterDelete / itemsPerPage);
                if (currentPage > totalPagesAfterDelete && totalPagesAfterDelete > 0) {
                  handlePageChange(totalPagesAfterDelete);
                }
              } else {
                toast.error(res.data.message || "Failed to recover ledger");
              }
            } catch (err) {
              console.error("Error recovering ledger:", err);
              toast.error(err?.response?.data?.message || " error fetching ledgers");
            } finally {
              handleDeleteModalClose();
            }
          }}
        />
      )}

    </div>
  );
}
